import { Database } from "types/supabase";
import { supabaseClient } from "supabase";
import { uploadImage } from "supabase/files";

export type CreateVenueParams = {
  name: Database["public"]["Tables"]["venues"]["Row"]["name"];
  address: Database["public"]["Tables"]["venues"]["Row"]["address"];
  city: Database["public"]["Tables"]["venues"]["Row"]["city"];
  city_id: Database["public"]["Tables"]["venues"]["Row"]["city_id"];
  phone: Database["public"]["Tables"]["venues"]["Row"]["phone"];
  website: Database["public"]["Tables"]["venues"]["Row"]["website"];
  description: Database["public"]["Tables"]["venues"]["Row"]["description"];
  description_pt: Database["public"]["Tables"]["venues"]["Row"]["description_pt"];
  newPicture?: File;
  location_lat: Database["public"]["Tables"]["venues"]["Row"]["location_lat"];
  location_long: Database["public"]["Tables"]["venues"]["Row"]["location_long"];
};

export const createVenue = async ({
  name,
  address,
  city,
  city_id,
  phone,
  website,
  description,
  description_pt,
  newPicture,
  location_lat,
  location_long,
}: CreateVenueParams) => {
  const createdVenue = {
    name,
    address,
    city,
    city_id,
    phone,
    website,
    description,
    description_pt,
    location_lat,
    location_long,
  };
  const { error, data } = await supabaseClient
    .from("venues")
    .insert(createdVenue)
    .select();

  if (error) {
    throw error;
  }

  // 33.3 WR-01: the row exists from here on. A picture that fails to upload
  // or save must not reject the create: the caller would not learn the new
  // id, and the natural retry (Create again) would insert a second row. The
  // failure is reported in `pictureFailed` instead.
  let pictureFailed = false;

  if (newPicture) {
    try {
      const picturePath = await uploadImage(
        newPicture,
        `${Date.now()}.${newPicture.type.split("/")[1]}`,
        "venues",
        data[0].uid
      );

      const { error: updateError } = await supabaseClient
        .from("venues")
        .update({ picture: picturePath })
        .eq("id", data[0].id);

      if (updateError) {
        throw updateError;
      }
    } catch {
      pictureFailed = true;
    }
  }

  // The id and name of the created venue, for the desk's Save as venue
  return { id: data[0].id, name: data[0].name, pictureFailed };
};
